// Conversão fiel entre os objetos do legado e as linhas relacionais.
// Campo desconhecido não se perde: vai para `extra` e volta intacto.
const r4 = v => (v === null || v === undefined || v === '' || Number.isNaN(Number(v))) ? 0 : Math.round(Number(v) * 1e4) / 1e4;
const r8 = v => (v === null || v === undefined || v === '' || Number.isNaN(Number(v))) ? 0 : Math.round(Number(v) * 1e8) / 1e8;
const r4n = v => (v === null || v === undefined || v === '') ? null : r4(v);
const str = v => (v === null || v === undefined) ? '' : String(v);
const bool = v => !!v;
const nnum = v => (v === null || v === undefined) ? 0 : Number(v);

const isoDate = v => {
  if (!v) return null;
  const s = String(v).trim();
  const br = /^(\d{1,2})[/\-.](\d{1,2})[/\-.](\d{4})/.exec(s);
  if (br) return `${br[3]}-${br[2].padStart(2, '0')}-${br[1].padStart(2, '0')}`;
  if (/^\d{4}-\d{2}-\d{2}/.test(s)) return s.slice(0, 10);
  const d = new Date(s);
  return Number.isNaN(d.getTime()) ? null : d.toISOString().slice(0, 10);
};
export const isoTs = v => {
  if (v === null || v === undefined || v === '') return null;
  const s = String(v).trim();
  const br = /^(\d{1,2})[/\-.](\d{1,2})[/\-.](\d{4})/.exec(s);
  if (br) return `${br[3]}-${br[2].padStart(2, '0')}-${br[1].padStart(2, '0')}T12:00:00.000Z`;
  const d = new Date(s);
  return Number.isNaN(d.getTime()) ? null : d.toISOString();
};

// [legado, coluna, paraLinha, deLinha]
const num4 = [r4, nnum], text = [str, str], boo = [bool, bool];
const flat = (map) => ({
  toRow(o, known = new Set(map.map(m => m[0]))) {
    const row = {};
    for (const [k, col, conv] of map) if (col) row[col] = conv[0](o[k]);
    const extra = {};
    for (const k of Object.keys(o)) if (!known.has(k) && o[k] !== undefined) extra[k] = o[k];
    row.extra = extra;
    return row;
  },
  fromRow(r) {
    const o = {};
    for (const [k, col, conv] of map) if (col) o[k] = conv[1](r[col]);
    return Object.assign(o, r.extra || {});
  },
});

const FIL = flat([
  ['id', null], ['marca', 'brand', text], ['tipo', 'material', text], ['cor', 'color', text],
  ['pesoOriginal', 'weight_original_g', num4], ['pesoAtual', null], ['preco', 'price', num4],
  ['custoPorGrama', 'cost_per_g', [r8, nnum]], ['dataCompra', 'purchase_date', [isoDate, v => v || '']],
  ['fornecedor', 'supplier_name', text], ['pesoMin', 'min_g', num4], ['obs', 'notes', text],
  ['fotoId', 'photo_id', [v => v || null, v => v || null]],
]);
export const filament = {
  stockOf: f => r4(f.pesoAtual),
  toRow: f => FIL.toRow(f),
  fromRow: r => ({ id: r.id, ...FIL.fromRow(r), pesoAtual: nnum(r.stock_g) }),
};

const ITEM = flat([
  ['id', null], ['nome', 'name', text], ['unidade', 'unit', text], ['qtdAtual', null], ['qtdMin', 'min_qty', num4],
  ['custoUnit', 'unit_cost', num4], ['categoria', 'category', [v => v ?? null, v => v ?? undefined]],
  ['tipo', 'item_type', [v => v ?? null, v => v ?? undefined]], ['fornecedor', 'supplier_name', text], ['obs', 'notes', text],
  ['fotoId', 'photo_id', [v => v || null, v => v || null]],
]);
export const KIND_BY_KEY = { insumos: 'insumo', embalagens: 'embalagem', outrosItens: 'outro' };
export const stockItem = {
  stockOf: i => r4(i.qtdAtual),
  toRow: (i, kind) => ({ ...ITEM.toRow(i), kind }),
  fromRow: r => {
    const o = { id: r.id, ...ITEM.fromRow(r), qtdAtual: nnum(r.stock_qty) };
    for (const k of ['categoria', 'tipo']) if (o[k] === undefined) delete o[k];
    if (r.kind !== 'insumo') delete o.fornecedor;
    return o;
  },
};

const PROD = flat([
  ['id', null], ['nome', 'name', text], ['sku', 'sku', text], ['categoria', 'category', text], ['descResumida', 'short_description', text],
  ['status', 'status', [v => v || 'ativo', str]], ['peso', 'weight_g', num4], ['tempoH', 'time_h', num4], ['tempoMin', 'time_min', num4],
  ['qtdPorImpressao', 'qty_per_print', [v => r4(v) || 1, nnum]], ['tipoFilamento', 'filament_type', text], ['corFilamento', 'filament_color', text],
  ['precoFilamento', 'filament_price', num4], ['desperdicio', 'waste_pct', num4], ['suporte', 'supports', boo], ['pctSuporte', 'support_pct', num4],
  ['controlarTempo', 'control_time', boo], ['potencia', 'power_w', num4], ['custoEnergia', 'energy_cost', num4],
  ['valorImpressora', 'printer_value', num4], ['vidaUtil', 'printer_life_h', num4], ['manutencaoH', 'maintenance_h', num4],
  ['outrosFixosH', 'other_fixed_h', num4], ['valorHora', 'labor_rate', num4], ['tempoPrep', 'prep_min', num4], ['tempoAcab', 'finish_min', num4],
  ['tempoEmb', 'pack_min', num4], ['custoEmb', 'pack_cost', num4], ['custoEtiq', 'label_cost', num4], ['outrosMateriais', 'other_materials', num4],
  ['outrosVariaveis', 'other_variable', num4], ['outrosFixos', 'other_fixed', num4], ['perdasAdc', 'losses_pct', num4],
  ['margem', 'margin_pct', num4], ['margemMin', 'margin_min_pct', num4], ['descontoMax', 'discount_max_pct', num4],
  ['precoPromo', 'promo_price', [r4n, v => (v === null || v === undefined) ? null : Number(v)]], ['descontoPromo', 'promo_discount_pct', num4],
  ['descricao', 'description', text], ['obs', 'notes', text], ['estoqueMin', 'stock_min', num4], ['estoqueMax', 'stock_max', num4],
  ['marketplaces', 'marketplaces', [v => v || {}, v => v || {}]],
]);
const PROD_DERIVED = new Set(['estoqueAtual', 'filamentos', 'filamentoId', 'fotoIds', 'fotoPrincipal', 'variacoes', 'createdAt']);
export const product = {
  stocksOf: p => Object.fromEntries((p.variacoes || []).map(v => [v.id, r4(v.estoqueAtual)])),
  toRow(p) {
    const row = PROD.toRow(p);
    for (const k of PROD_DERIVED) delete row.extra[k];
    if (p.createdAt) row.created_at = p.createdAt;
    row.variations = (p.variacoes || []).map((v, i) => ({
      id: v.id, name: str(v.nome), photo_id: v.fotoId || null, sort_order: i,
      materials: (v.filamentos || []).map(m => ({ filament_id: m.filamentoId, grams_per_unit: r4(m.gramasPorUnidade) })),
    }));
    row.images = (p.fotoIds || []).map((id, i) => ({ media_id: id, position: i, is_main: id === p.fotoPrincipal }));
    return row;
  },
  fromRow(r, variations = [], materials = [], images = []) {
    const vs = variations.filter(v => v.product_id === r.id && !v.deleted_at).sort((a, b) => a.sort_order - b.sort_order);
    const variacoes = vs.map(v => ({
      id: v.id, nome: v.name, fotoId: v.photo_id || null, estoqueAtual: nnum(v.stock_qty),
      filamentos: materials.filter(m => m.variation_id === v.id).sort((a, b) => a.position - b.position)
        .map(m => ({ filamentoId: m.filament_id, gramasPorUnidade: nnum(m.grams_per_unit) })),
    }));
    const imgs = images.filter(i => i.product_id === r.id).sort((a, b) => a.position - b.position);
    const o = { id: r.id, ...PROD.fromRow(r), variacoes, fotoIds: imgs.map(i => i.media_id), fotoPrincipal: (imgs.find(i => i.is_main) || {}).media_id || null, createdAt: r.created_at };
    const first = variacoes[0];
    o.estoqueAtual = variacoes.reduce((s, v) => s + v.estoqueAtual, 0);
    o.filamentos = first ? first.filamentos.map(m => ({ ...m })) : [];
    o.filamentoId = o.filamentos[0]?.filamentoId || null;
    return o;
  },
};

// Colunas financeiras da venda: congeladas no momento da venda; relatórios nunca recalculam pelo produto atual.
const SALE = flat([
  ['id', null], ['canal', 'channel', [v => v || 'direta', str]], ['status', 'status', text], ['formaPagamento', 'payment_method', text],
  ['desconto', 'discount', num4], ['taxaPct', 'fee_pct', num4], ['taxaFixa', 'fee_fixed', num4], ['taxaValor', 'fee_value', num4],
  ['freteCliente', 'shipping_customer', num4], ['freteVendedor', 'shipping_seller', num4], ['outrosCustos', 'other_costs', num4],
  ['receitaBruta', 'gross_revenue', num4], ['receitaLiquida', 'net_revenue', num4], ['custoProdutos', 'product_cost', num4],
  ['lucro', 'profit', num4], ['margem', 'margin_pct', num4], ['markup', 'markup_pct', num4], ['estoqueBaixado', 'stock_applied', boo], ['obs', 'notes', text],
]);
const SALE_DERIVED = new Set(['data', 'produtoId', 'varianteId', 'varianteNome', 'qtd', 'precoUnit', 'bruta', 'descontoValor', 'totalDescontos', 'lucroUnidade', 'produtoNome']);
export const sale = {
  toRow(v, productNameOf = () => '') {
    const row = SALE.toRow(v);
    for (const k of SALE_DERIVED) delete row.extra[k];
    row.occurred_at = isoTs(v.data);
    row.items = [{ product_id: v.produtoId || null, variation_id: v.varianteId || null, product_name: v.produtoNome || productNameOf(v.produtoId),
      variation_name: str(v.varianteNome), qty: r4(v.qtd), unit_price: r4(v.precoUnit) }];
    return row;
  },
  fromRow(r, items = []) {
    const it = items.filter(i => i.sale_id === r.id).sort((a, b) => a.position - b.position)[0] || {};
    const o = { id: r.id, data: r.occurred_at, ...SALE.fromRow(r), produtoId: it.product_id ?? null, varianteId: it.variation_id ?? undefined,
      varianteNome: it.variation_name || '', produtoNome: it.product_name || '', qtd: nnum(it.qty), precoUnit: nnum(it.unit_price) };
    o.bruta = o.receitaBruta; o.descontoValor = o.desconto; o.totalDescontos = o.desconto;
    o.lucroUnidade = o.qtd > 0 ? o.lucro / o.qtd : 0;
    return o;
  },
};

const PRO = flat([
  ['id', null], ['varianteNome', 'variation_name', text], ['tempo', 'time_h', num4], ['peso', 'weight_g', num4], ['custoFil', 'filament_cost', num4],
  ['custoExtras', 'extras_cost', num4], ['usouEmbPadrao', 'used_default_packaging', boo], ['custoTotal', 'total_cost', num4], ['custoUnidade', 'unit_cost', num4],
  ['controlarTempo', 'control_time', boo], ['obs', 'notes', text],
]);
const PRO_DERIVED = new Set(['data', 'produtoId', 'varianteId', 'qtd', 'status', 'estoqueAplicado', 'materiais', 'extras', 'filamentoId', 'inicio', 'terminoPrevisto', 'concluidaEm', 'canceladaEm', 'revertidaEm', 'produtoNome']);
const EXTRA_KIND = { insumo: 'insumo', embalagem: 'embalagem', outro: 'outro', outros: 'outro', outrosItens: 'outro' };
export const production = {
  toRow(pr, productNameOf = () => '') {
    const row = PRO.toRow(pr);
    for (const k of PRO_DERIVED) delete row.extra[k];
    Object.assign(row, {
      occurred_at: isoTs(pr.data), product_id: pr.produtoId || null, variation_id: pr.varianteId || null,
      product_name: pr.produtoNome || productNameOf(pr.produtoId), qty: r4(pr.qtd), status: pr.status || 'concluida',
      stock_applied: pr.estoqueAplicado === undefined ? null : !!pr.estoqueAplicado,
      started_at: isoTs(pr.inicio), due_at: isoTs(pr.terminoPrevisto), completed_at: isoTs(pr.concluidaEm), cancelled_at: isoTs(pr.canceladaEm), reverted_at: isoTs(pr.revertidaEm),
    });
    const mats = (pr.materiais || []).map(m => ({ item_kind: 'filamento', item_id: m.filamentoId, item_name: '', brand: str(m.marca), material: str(m.tipo), color: str(m.cor), qty: r4(m.gramas), cost: r4(m.custo), unit: 'g' }));
    const ex = (pr.extras || []).map(e => ({ item_kind: EXTRA_KIND[e.tipo] || 'outro', item_id: e.itemId, item_name: str(e.nome), unit: str(e.unidade), qty_per_unit: e.qtdPorUn ?? null, qty: r4(e.qtd), unit_cost: r8(e.custoUnit), cost: r4(e.custo) }));
    row.materials = [...mats, ...ex];
    return row;
  },
  fromRow(r, mats = []) {
    const own = mats.filter(m => m.production_id === r.id).sort((a, b) => a.position - b.position);
    const o = { id: r.id, data: r.occurred_at, ...PRO.fromRow(r), produtoId: r.product_id, varianteId: r.variation_id ?? undefined, produtoNome: r.product_name, qtd: nnum(r.qty), status: r.status };
    if (r.stock_applied !== null && r.stock_applied !== undefined) o.estoqueAplicado = r.stock_applied;
    const dates = { inicio: r.started_at, terminoPrevisto: r.due_at, concluidaEm: r.completed_at, canceladaEm: r.cancelled_at, revertidaEm: r.reverted_at };
    for (const [k, v] of Object.entries(dates)) if (v) o[k] = v;
    o.materiais = own.filter(m => m.item_kind === 'filamento').map(m => ({ filamentoId: m.item_id, marca: m.brand, tipo: m.material, cor: m.color, gramas: nnum(m.qty), custo: nnum(m.cost) }));
    o.extras = own.filter(m => m.item_kind !== 'filamento').map(m => ({ tipo: m.item_kind, itemId: m.item_id, nome: m.item_name, unidade: m.unit, qtdPorUn: m.qty_per_unit === null ? undefined : nnum(m.qty_per_unit), qtd: nnum(m.qty), custoUnit: nnum(m.unit_cost), custo: nnum(m.cost) }));
    o.filamentoId = o.materiais[0]?.filamentoId || null;
    return o;
  },
};

const CMP = flat([
  ['id', null], ['grupo', 'group_kind', [v => v === 'investimento' ? 'investimento' : 'compra', str]], ['categoria', 'category', text], ['descricao', 'description', text],
  ['fornecedor', 'supplier_name', text], ['qtd', 'qty', num4], ['valor', 'amount', num4], ['obs', 'notes', text],
  ['origem', 'origin', [v => v || 'manual', str]], ['origemId', 'origin_id', text], ['editadoManual', 'edited_manually', boo],
]);
export const purchase = {
  toRow: c => { const row = CMP.toRow(c); delete row.extra.data; row.purchase_date = isoDate(c.data); return row; },
  fromRow: r => { const o = { id: r.id, data: r.purchase_date, ...CMP.fromRow(r) }; if (!o.editadoManual) delete o.editadoManual; return o; },
};

const MOV_TYPES = new Set(['entrada', 'saida', 'ajuste', 'consumo', 'venda', 'producao', 'perda', 'avaria', 'devolucao', 'reversao', 'legado']);
const MOV_KIND = { produto: 'produto', filamento: 'filamento', insumo: 'insumo', insumos: 'insumo', embalagem: 'embalagem', embalagens: 'embalagem', outro: 'outro', outros: 'outro', outrosItens: 'outro' };
export const movement = {
  toRow(m) {
    const known = MOV_TYPES.has(m.tipo);
    return {
      id: m.id, occurred_at: isoTs(m.data) || new Date().toISOString(), item_kind: MOV_KIND[m.itemTipo] || 'outro', item_id: str(m.itemId),
      variation_id: m.varianteId || null, item_name: str(m.itemNome), mov_type: known ? m.tipo : 'legado',
      qty_in: r4(m.entrada), qty_out: r4(m.saida), qty_before: r4(m.anterior), qty_after: r4(m.posterior),
      reason: str(m.motivo), reference: str(m.referencia), notes: known ? str(m.obs) : `[tipo original: ${m.tipo}] ${str(m.obs)}`,
    };
  },
  fromRow: r => {
    const o = { id: r.id, data: r.occurred_at, itemId: r.item_id, itemNome: r.item_name, itemTipo: r.item_kind, tipo: r.mov_type,
      entrada: nnum(r.qty_in), saida: nnum(r.qty_out), anterior: nnum(r.qty_before), posterior: nnum(r.qty_after),
      motivo: r.reason, referencia: r.reference, obs: r.notes };
    if (r.variation_id) o.varianteId = r.variation_id;
    return o;
  },
};

const MK = [['name', 'name', str], ['taxaPct', 'fee_pct', r4], ['taxaFixa', 'fee_fixed', r4], ['custosAdc', 'additional_costs', r4], ['margem', 'margin_pct', r4], ['impostos', 'tax_pct', r4], ['descontoMedio', 'avg_discount_pct', r4], ['frete', 'shipping', r4]];
export const marketplace = {
  toRow: (channel, p) => Object.fromEntries([['channel', channel], ...MK.map(([k, c, f]) => [c, f(p[k])])]),
  fromRows: rows => Object.fromEntries(rows.map(r => [r.channel, Object.fromEntries(MK.map(([k, c]) => [k, k === 'name' ? r[c] : nnum(r[c])]))])),
};
// Logo nunca vai dentro do JSON de configurações: fica no Storage, referenciada por media:<id>.
export const logoMediaId = dataUrl => { let h = 5381; for (let i = 0; i < dataUrl.length; i++) h = (h * 33 ^ dataUrl.charCodeAt(i)) >>> 0; return 'logo_' + h.toString(36) + '_' + dataUrl.length; };
export const settingsDoc = {
  toRow: s => {
    const { platforms, ...rest } = s; const logo = rest.systemIdentity?.logo;
    if (typeof logo === 'string' && logo.startsWith('data:')) rest.systemIdentity = { ...rest.systemIdentity, logo: 'media:' + logoMediaId(logo) };
    return { data: rest };
  },
  fromRows: (row, mkRows) => ({ ...(row?.data || {}), ...(mkRows.length ? { platforms: marketplace.fromRows(mkRows) } : {}) }),
};
